(() => {
try {
    const getCookie = (key)=>{
        const filtered = document.cookie.split(";").map((x)=>x.split("=")).filter((x)=>x[0].replace(/ /, "") === key);
        return !filtered.length ? null : decodeURIComponent(filtered[0][1]);
    };
    const postEvent = (testPatternId, url, eventType, clickId)=>{
        const requestUrl = new URL(String("https://hlsmnyijsghjmafdkrjy.supabase.co/functions/v1/event"));
        fetch(requestUrl, {
            method: "POST",
            mode: "cors",
            headers: {
                "Authorization": `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhsc21ueWlqc2doam1hZmRrcmp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTUzNjIwNTAsImV4cCI6MjAxMDkzODA1MH0.ytpTOvqynmpZtlaKY91pALpk-8vPrA-AlpjPaYtF3uY"}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "test_pattern_id": testPatternId,
                "url": url,
                "event_type": eventType,
                "click_id": clickId
            })
        });
    };
    const testId = getCookie("beastt:test_id");
    if (!testId) throw new Error("test_id is undefined");
    const testPatternId = getCookie("beastt:test_pattern_id");
    if (!testPatternId) throw new Error("test_pattern_id is undefined");
    postEvent(testPatternId, location.href, "screen_view", null);
    // イベントリスナーを保持するためのオブジェクト
    // イベントリスナーを削除する可能性があるが、削除時にリスナーを指定しなければいけないのでこのオブジェクトが必要である。
    const eventListeners = {};
    // クリックイベントハンドラ
    const clickEventHandler = (clickId)=>{
        return ()=>{
            postEvent(testPatternId, location.href, "click", clickId);
        };
    };
    // ドキュメントの読み込み完了時にすでに存在するノードへのクリックイベント付与
    const nodeList = document.querySelectorAll("[data-beastt-click-id]");
    nodeList.forEach((node)=>{
        const clickId = node.getAttribute("data-beastt-click-id");
        if (clickId) {
            const listener = clickEventHandler(clickId);
            node.addEventListener("click", listener);
            eventListeners[clickId] = listener;
        }
    });
    // ドキュメントの読み込み完了後にDOMに変更があった場合の処理
    const mutationCallback = (mutationsList)=>{
        mutationsList.forEach((mutation)=>{
            // ノードが追加された場合
            mutation.addedNodes.forEach((element)=>{
                if (element instanceof HTMLElement && element.hasAttribute("data-beastt-click-id")) {
                    const clickId = element.getAttribute("data-beastt-click-id");
                    if (clickId) {
                        const listener = clickEventHandler(clickId);
                        element.addEventListener("click", listener);
                        eventListeners[clickId] = listener;
                    }
                }
            });
            // ノードが削除された場合
            mutation.removedNodes.forEach((element)=>{
                if (element instanceof HTMLElement && element.hasAttribute("data-beastt-click-id")) {
                    const clickId = element.getAttribute("data-beastt-click-id");
                    if (clickId) {
                        const listener = eventListeners[clickId];
                        element.removeEventListener("click", listener);
                    }
                }
            });
            // 既存のノードのdata-beastt-click-idプロパティが変更された場合
            const element = mutation.target;
            if (mutation.type === "attributes" && mutation.attributeName === "data-beastt-click-id") {
                const oldClickId = mutation.oldValue;
                if (oldClickId) {
                    const listener = eventListeners[oldClickId];
                    element.removeEventListener("click", listener);
                }
                const newClickId = element.getAttribute("data-beastt-click-id");
                if (newClickId) {
                    const listener = clickEventHandler(newClickId);
                    element.addEventListener("click", listener);
                    eventListeners[newClickId] = listener;
                }
            }
        });
    };
    // Mutation Observerの設定
    const observer = new MutationObserver(mutationCallback);
    const observerConfig = {
        attributes: true,
        childList: true,
        subtree: true,
        attributeOldValue: true
    };
    observer.observe(document, observerConfig);
} catch (e) {
    console.log(`Beastt: monitor does not work because ${e}`);
// Do nothing
}

})();
//# sourceMappingURL=monitor.js.map
